export const isMobile = () => {
  const mobiles = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  return mobiles.some((matches) => navigator.userAgent.match(matches));
};

export const COOKIE_NAME = 'ac-admin';
export const API_URL = process.env.REACT_APP_API;
export const IS_MAINNET = process.env.REACT_APP_ENV !== 'testnet';
